class CollectionDescriptionToggle extends HTMLElement {
  constructor() {
    super();
    this.wrapper = null;
    this.description = null;
    this.toggle = null;
    this.textMore = null;
    this.textLess = null;
    this.resizeHandler = null;
    this.mobileBreakpoint = 767;
  }

  connectedCallback() {
    this.wrapper = this.querySelector('[data-wrapper]');
    this.description = this.querySelector('[data-description]');
    this.toggle = this.querySelector('[data-toggle]');
    
    if (!this.wrapper || !this.description || !this.toggle) {
      return;
    }

    this.textMore = this.toggle.querySelector('.toggle-text-more');
    this.textLess = this.toggle.querySelector('.toggle-text-less');

    this.handleToggleClick = this.handleToggleClick.bind(this);
    this.checkIfClamped = this.checkIfClamped.bind(this);

    this.toggle.addEventListener('click', this.handleToggleClick);
    
    this.resizeHandler = this.checkIfClamped;
    window.addEventListener('resize', this.resizeHandler);

    this.checkIfClamped();
  }

  disconnectedCallback() {
    if (this.toggle) {
      this.toggle.removeEventListener('click', this.handleToggleClick);
    }
    
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler);
    }
  }

  checkIfClamped() {
    if (window.innerWidth > this.mobileBreakpoint) {
      this.wrapper.classList.add('no-clamp');
      return;
    }

    const wasExpanded = this.description.classList.contains('is-expanded');
    this.description.classList.add('is-expanded');
    
    const lineHeight = parseFloat(window.getComputedStyle(this.description).lineHeight);
    const maxHeight = lineHeight * 2.5;
    const isClamped = this.description.scrollHeight > maxHeight;
    
    if (!wasExpanded) {
      this.description.classList.remove('is-expanded');
    }
    
    if (!isClamped) {
      this.wrapper.classList.add('no-clamp');
    } else {
      this.wrapper.classList.remove('no-clamp');
    }
  }

  handleToggleClick(e) {
    e.preventDefault();
    const isExpanded = this.description.classList.toggle('is-expanded');
    this.toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    
    if (isExpanded) {
      if (this.textMore) this.textMore.style.display = 'none';
      if (this.textLess) this.textLess.style.display = 'inline';
    } else {
      if (this.textMore) this.textMore.style.display = 'inline';
      if (this.textLess) this.textLess.style.display = 'none';
    }
  }
}

if (!customElements.get('collection-description-toggle')) {
  customElements.define('collection-description-toggle', CollectionDescriptionToggle);
}
